import { BaseGenerator } from 'utils/pdfUtils/BaseGenerator';
import { Subscript } from '../Subscript';

export class GenerateTornadoTable extends BaseGenerator {
  constructor(doc, headers, rows, startingHeight = 50, start = 50, resultsIndent = 25, rowHeight = 15, p = 10) {
    super(doc, headers, rows, startingHeight, start, resultsIndent, rowHeight, p);
    this.headers = headers;
    this.rows = rows;
    this.output();
  }

  /**
   * Generate the table and return the existing `doc` instance
   *
   * @return obj   this.doc - returns the instance of `doc` that was provided to the constructor
   */

  output() {
    let single_char_width = 8;
    [
      { kLeft: this.start, vLeft: 75 },
      { kLeft: 100, vLeft: 175 },
      { kLeft: 200, vLeft: 275 },
      { kLeft: 300, vLeft: 375 },
      { kLeft: 400, vLeft: 475 },
      { kLeft: 500, vLeft: 575 },
    ].forEach((column, column_index) => {
      let columnData = [];
      columnData.push(this.headers[column_index]);
      Object.keys(this.rows).forEach((key) => columnData.push(this.rows[key][column_index]));

      let idx = 0;
      columnData.forEach((value) => {
        let cursorY = this.startingHeight + this.rowHeight * (5 + idx);

        let needsSubscript = value.indexOf('Ae') > -1 || value.indexOf('Vt') > -1;
        if (needsSubscript) {
          let pieces = value.split(' = ');
          let subscript = new Subscript(pieces[0]);
          subscript.output_obj;
          let first_chars = subscript.output_obj.uc;
          let first_chars_width = 0;
          first_chars.split('').forEach((chr) => {
            first_chars_width += chr in Subscript.character_widths ? Subscript.character_widths[chr] : 7;
          });
          let remaining_chars = subscript.output_obj.lc;
          let label_width = value.length * single_char_width;
          let remainingString = ' = ' + pieces[1];
          console.log(first_chars + remaining_chars + remainingString);
          this.doc
            .font('Helvetica')
            .text(first_chars, column.kLeft + this.resultsIndent, cursorY)
            .fontSize(this.p * 0.6)
            .text(remaining_chars, column.kLeft + this.resultsIndent + first_chars_width, cursorY + 4)
            .fontSize(this.p)
            // .text(': ', column.kLeft + this.resultsIndent + label_width, cursorY)
            .text(remainingString, column.kLeft + this.resultsIndent + (first_chars_width + 5), cursorY);
        } else {
          console.log(value);
          this.doc.font('Helvetica').text(value, column.kLeft + this.resultsIndent, cursorY);
        }

        idx++;
      });
    });
    return this.doc;
  }
}
